import { ErrorInfo } from 'react';
import storeModule from '@store';
import { sendLog } from '@reducers/dataDogs';
import { buildErrorBoundaryLogTitle } from '@reducers/dataDogs/helpers';
import { navigationRef, isWeb } from '@helpers';

export const getDatadogSessionId = async (): Promise<string | undefined> => {
  try {
    if (isWeb) {
      const { datadogLogs } = require('@datadog/browser-logs');
      return datadogLogs.getInternalContext()?.session_id;
    }
    const { DdRum } = require('@datadog/mobile-react-native');
    return await DdRum.getCurrentSessionId();
  } catch {
    return undefined;
  }
};

export const logErrorToDatadog = (error: Error, errorInfo: ErrorInfo | null, screenName?: string, sessionId?: string): void => {
  try {
    const currentRoute = navigationRef.current?.getCurrentRoute()?.name || 'Unknown';
    const logScreenName = screenName || currentRoute;

    storeModule.store.dispatch(
      sendLog({
        title: buildErrorBoundaryLogTitle(logScreenName),
        data: {
          source: 'ErrorBoundary',
          errorName: error.name,
          errorMessage: error.message,
          componentStack: errorInfo?.componentStack || 'N/A',
          jsStack: error.stack || 'N/A',
          screenName: logScreenName,
          url: isWeb ? window.location?.href : '',
          datadogSessionId: sessionId || 'N/A',
        },
        status: 'error',
      })
    );
  } catch (e) {
    console.error('[ErrorBoundary] Failed to log to Datadog:', e);
    console.error('[ErrorBoundary] Original error:', error);
  }
};
